import { FC, memo } from 'react';
import { CgMail, CgPhone } from 'react-icons/cg';
import { Flex, FlexProps, Stack, Text } from '@chakra-ui/react';

import { ContactEntry } from './types/ContactEntry';

const ContactCardComponent: FC<FlexProps & { contact: ContactEntry }> = ({
  contact,
  ...props
}) => (
  <Flex direction="column" {...props}>
    {contact.name && <Text>{contact.name}</Text>}

    {contact.company && (
      <Text color="brandPrimary.fg" fontSize="sm">
        {contact.company}
      </Text>
    )}

    <Stack fontSize="sm">
      <Text color="fg.muted">{contact.title}</Text>
      <Stack>
        {contact.phone && (
          <Flex alignItems="center">
            <CgPhone />
            <Text ml={1}>{contact.phone}</Text>
          </Flex>
        )}
        {contact.email && (
          <Flex alignItems="center">
            <CgMail />
            <Text ml={1}>{contact.email}</Text>
          </Flex>
        )}
      </Stack>
    </Stack>
  </Flex>
);

export const ContactCard = memo(ContactCardComponent);
